import React from 'react';
import { Flex } from '@chakra-ui/react';
import Navbar from './Navbar/Navbar';

const LayoutWithNavbar = ({ children }) => {
    return (
        <Flex direction="column" height="100vh">
            <Navbar />

            <Flex direction="column" flex="1">
                {children}
            </Flex>

        </Flex>
    );
}

export default LayoutWithNavbar;